import { defineMessages } from 'react-intl';

const messages = defineMessages({
  description: {
    id: 'onboardingPages.clientOnboarding.timezoneLanguageStep.description',
    defaultMessage: 'Choose your timezone and language',
  },
  language: {
    id: 'onboardingPages.clientOnboarding.timezoneLanguageStep.language',
    defaultMessage: 'Language',
  },
  timezone: {
    id: 'onboardingPages.clientOnboarding.timezoneLanguageStep.timezone',
    defaultMessage: 'Timezone',
  },
  title: {
    id: 'onboardingPages.clientOnboarding.timezoneLanguageStep.title',
    defaultMessage: "Let's get started",
  },
});

export default messages;
